<script setup>
import { get_tickets, update_ticket } from '@/services/tickets';
import { onMounted, ref } from 'vue';
import { formattedDate, swalError, swalSuccess } from '@/helper';

const tickets = ref([])
const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_tickets()
  isLoading.value = false
})

async function retrieve_tickets(){
  let response = await get_tickets('feedback')
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  tickets.value = response.result.data.data
}

async function archiveTicket(ticket){
  let params = {
    is_archive: 1
  }
  let response = await update_ticket(ticket.id, params)
  if(response.error){
    swalError(response.result, true)
    return
  }
  ticket.attributes.is_archive = 1
  swalSuccess("Ticket has been archive")
}

const filter = ref({
  value: 9
})
</script>

<template>
  <Breadcrumbs main="Feedback List"/>
  
  <div class="container-fluid">
    <div class="row">
      <!-- Page Title -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="mb-0">Intervention Feedback List</h4>
          </div>
        </div>
      </div>

      <div class="d-flex mb-4">
        <button class="btn rounded-pill btn-light-primary me-2"
          @click="filter.value = 9"
          :class="filter.value == 9 ? 'active' : ''"
        >
          All
        </button>
        <button class="btn rounded-pill btn-light-primary me-2"
          @click="filter.value = 0"
          :class="filter.value == 0 ? 'active' : ''"
        >
          Not Archived
        </button>
        <button class="btn rounded-pill btn-light-primary"
          @click="filter.value = 1"
          :class="filter.value == 1 ? 'active' : ''"
        >
          Archived
        </button>
      </div>
      
      <!-- Item List -->
      <template v-if="isLoading">
        <loadingCard />
      </template>
      <template v-else>
        <template v-if="tickets == 0">
          <emptyCard />
        </template>
        <template v-else>
          <div class="col-md-12 mb-2">
            <div class="card mb-1 rounded-0">
              <div class="card-body py-1">
                <div class="row">
                  <div class="col-5 my-auto">
                    <p class="text-truncate">
                      Subject
                    </p>
                  </div>
                  <div class="col-3">
                    <p class="text-center">Topic</p>
                  </div>
                  <div class="col-2">
                    <p class="text-center">Action</p>
                  </div>
                  <div class="col-2 d-flex justify-content-start align-items-center">
                    <p class="text-center">Date Created</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-for="ticket in tickets" :key="ticket.id">
            <div v-auto-animate v-if="filter.value == ticket.attributes.is_archive" class="mb-1">
              <div class="col-md-12">
                <div class="card mb-1">
                  <div class="card-body py-3">
                    <div class="row">
                      <div class="col-5 my-auto">
                        <p class="text-truncate">
                          {{ ticket.attributes.subject }}
                        </p>
                      </div>
                      <div class="col-2 mx-auto">
                        <div class="rounded-pill bg-body-secondary text-center p-2">
                          <p>{{ ticket.attributes.topic }}</p>
                        </div>
                      </div>
                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <button class="btn btn-light-danger icon-btn"
                          @click="archiveTicket(ticket)"
                          :class="ticket.attributes.is_archive ? 'disabled' : ''"
                        >
                          <vue-feather type="archive" size="1rem" />
                        </button>
                        <router-link class="btn btn-light-success icon-btn ms-1"
                          :to="{name: 'support-view', params: {id: ticket.id}}"
                        >
                          <vue-feather type="chevron-right" size="1rem" />
                        </router-link>
                      </div>
                      <div class="col-2 d-flex justify-content-start align-items-center">
                        <p class="text-center">{{ formattedDate(ticket.attributes.created_at) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-auto-animate v-if="filter.value == 9" class="mb-1">
              <div class="col-md-12">
                <div class="card mb-1">
                  <div class="card-body py-3">
                    <div class="row">
                      <div class="col-5 my-auto">
                        <p class="text-truncate">
                          {{ ticket.attributes.subject }}
                        </p>
                      </div>
                      <div class="col-2 mx-auto">
                        <div class="rounded-pill bg-body-secondary text-center p-2">
                          <p>{{ ticket.attributes.topic }}</p>
                        </div>
                      </div>
                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <button class="btn btn-light-danger icon-btn"
                          @click="archiveTicket(ticket)"
                          :class="ticket.attributes.is_archive ? 'disabled' : ''"
                        >
                          <vue-feather type="archive" size="1rem" />
                        </button>
                        <router-link class="btn btn-light-success icon-btn ms-1"
                          :to="{name: 'support-view', params: {id: ticket.id}}"
                        >
                          <vue-feather type="chevron-right" size="1rem" />
                        </router-link>
                      </div>
                      <div class="col-2 d-flex justify-content-start align-items-center">
                        <p class="text-center">{{ formattedDate(ticket.attributes.created_at) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>